<template>
    <v-dialog v-model="dialog" max-width="540px">
        <template v-slot:activator="{ on }">
            <v-btn
                block
                depressed
                height="41"
                class="btn-edurent"
                color="primary"
                v-on="on"
            >
                Match with Me
            </v-btn>
        </template>
        <v-card class="contact-roommate px-6 px-md-12">

            <div class="modal-close-btn">
                <v-btn icon>
                    <v-icon size="18" color="grey" @click="modalClose">mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card-text class="py-6 py-md-10 px-4 px-md-12">
                <v-row>
                    <v-col class="d-flex justify-center flex-column flex-md-row">
                        <h4 class="text-center mr-0 mr-md-2">Contact</h4>
                        <h4 class="text-center">{{ name }}</h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="d-flex justify-center">
                        <p class="text-center">
                            Write your own message or select from the topics below to generate a message
                        </p>
                    </v-col>
                </v-row>
                <v-row class="px-2">
                    <v-col class="px-1 pb-0">
                        <v-btn
                            outlined
                            @click="toggleSchoolText"
                            height="30"
                            block
                            class="btn-edurent"
                            :class="{ 'topic-selected': selectedTopics.school }"
                            :color="selectedTopics.school ? 'primary' : 'rgba(0,0,0,0.2)'"
                        >
                            School
                        </v-btn>
                    </v-col>
                    <v-col class="px-1 pb-0">
                        <v-btn
                            outlined
                            @click="toggleSchoolDate"
                            height="30"
                            block
                            class="btn-edurent"
                            :class="{ 'topic-selected': selectedTopics.schoolDate }"
                            :color="selectedTopics.schoolDate ? 'primary' : 'rgba(0,0,0,0.2)'"
                        >
                            School Start Date
                        </v-btn>
                    </v-col>
                    <v-col class="px-1 pb-0">
                        <v-btn
                            outlined
                            @click="toggleInterests"
                            height="30"
                            block
                            class="btn-edurent"
                            :class="{ 'topic-selected': selectedTopics.interests }"
                            :color="selectedTopics.interests ? 'primary' : 'rgba(0,0,0,0.2)'"
                        >
                            Interests
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-textarea
                            rows="6"
                            outlined
                            block
                            v-model="message"
                            label="Message"
                            placeholder="Write a message"
                            hide-details="auto"
                            solo
                            flat
                            no-resize
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn
                            block
                            height="45"
                            depressed
                            class="btn-edurent send-btn"
                            color="primary"
                            @click="send"
                            :disabled="$v.$invalid"
                            :loading="isMessageSending"
                        >
                            Send Message
                        </v-btn>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { UserService } from "@/services/user.service";

export default {
    name: "ContactRoommateDialog",
    props: ["name", "roommateId"],
    validations: {
        message: { required }
    },
    data: () => ({
        message: "",
        dialog: false,
        isMessageSending: false,
        selectedTopics: {
            school: false,
            schoolDate: false,
            interests: false
        }
    }),
    methods: {
        send: async function() {
            if (!this.isUserLoggedIn) {
                this.$store.dispatch("setSignInModal", true);
                return;
            }
            this.$v.$touch();

            this.isMessageSending = true;

            // send get info message
            await UserService.sendRoommateContactMessage({
                message: this.message,
                roommateId: this.roommateId
            });

            this.isMessageSending = false;

            this.clear();
            this.dialog = false;
        },
        getSchoolText() {
            return `Hi, I'm ${this.user.name}! I'm looking for a roommate and EDUrent suggested you as a match. `;
        },
        getSchoolDateText() {
            return `I start school ${this.user.university_start_date}. `;
        },
        getInterestsText() {
            return `My interests include: ${this.user.hobbies}. `;
        },
        toggleSchoolText() {
            if (!this.isUserLoggedIn) {
                this.$store.dispatch("setSignInModal", true);
                return;
            }
            if (this.selectedTopics.school) {
                this.message = this.message.replace(this.getSchoolText(), "");
                this.selectedTopics.school = false;
            } else {
                this.message += this.getSchoolText();
                this.selectedTopics.school = true;
            }
        },
        toggleSchoolDate() {
            if (!this.isUserLoggedIn) {
                this.$store.dispatch("setSignInModal", true);
                return;
            }
            if (this.selectedTopics.schoolDate) {
                this.message = this.message.replace(this.getSchoolDateText(), "");
                this.selectedTopics.schoolDate = false;
            } else {
                this.message += this.getSchoolDateText();
                this.selectedTopics.schoolDate = true;
            }
        },
        toggleInterests() {
            if (!this.isUserLoggedIn) {
                this.$store.dispatch("setSignInModal", true);
                return;
            }
            if (this.selectedTopics.interests) {
                this.message = this.message.replace(this.getInterestsText(), "");
                this.selectedTopics.interests = false;
            } else {
                this.message += this.getInterestsText();
                this.selectedTopics.interests = true;
            }
        },
        resetSelectedTopics() {
            this.selectedTopics = {
                school: false,
                schoolDate: false,
                interests: false
            };
        },
        clear() {
            this.$v.$reset();
            this.message = "";
            this.resetSelectedTopics();
        },
        modalClose() {
            this.dialog = false;
            this.resetSelectedTopics();
            this.message = "";
        }
    },
    computed: {
        isUserLoggedIn() {
            return this.$store.getters.isUserLoggedIn;
        },
        isLoading() {
            return this.$store.getters.fetching;
        },
        user() {
            return this.$store.getters.getUser;
        },
        messageErrors() {
            const errors = [];
            if (!this.$v.message.$dirty) return errors;
            !this.$v.message.required && errors.push("Message is required.");
            return errors;
        }
    }
};
</script>
<style>

.contact-roommate h4 {
    font-weight: 700 !important;
    font-size: 20px !important;
    color: #000;
}

.contact-roommate p {
    font-weight: 400 !important;
    font-size: 14px !important;
    color: #000;
}

.contact-roommate .v-btn__content {
    color: #000000;
}

.contact-roommate .send-btn .v-btn__content {
    color: white !important;
}

.contact-roommate .v-input--checkbox label {
    color: #000;
    font-size: 14px;
}

.contact-roommate {
    border-radius: 10px !important;
}

.contact-roommate .topic-selected {
    background: rgba(45, 118, 227, 0.15) !important;
    border-color: #2D76E3 !important;
    color: #2D76E3 !important;
}

.contact-roommate .topic-selected .v-btn__content {
    color: #2D76E3 !important;
}

.contact-roommate textarea {
    font-size: 14px !important;
    line-height: 21px;
}

</style>
